var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoading(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 46,
    viewBox: "0 0 53 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\xEB\xA9\x94\xEC\x9D\xB8 \xEC\x8B\xAC\xEB\xB3\xBC"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M3.86351 46.0001C3.02576 46.0001 2.18643 45.6943 1.52976 45.0765C0.173919 43.8004 0.120378 41.6756 1.40851 40.3324C9.52625 31.8722 9.52625 18.6194 1.40851 10.1592C0.120378 8.81602 0.173919 6.69277 1.52976 5.41508C2.88561 4.13739 5.02882 4.19199 6.31852 5.5352C16.9259 16.5882 16.9259 33.9034 6.31852 44.9549C5.65241 45.6491 4.75954 45.9985 3.86351 45.9985V46.0001Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M48.8988 46.0005C48.0028 46.0005 47.1099 45.651 46.4438 44.9568C35.8364 33.9038 35.8364 16.5886 46.4438 5.53558C47.732 4.19236 49.8767 4.13932 51.2326 5.41545C52.5884 6.69158 52.642 8.81639 51.3538 10.1596C43.2345 18.6198 43.2345 31.8726 51.3538 40.3328C52.642 41.676 52.5884 43.7992 51.2326 45.0769C50.5775 45.6947 49.7382 46.0005 48.8988 46.0005Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M26.5144 25.4245C18.803 25.4245 12.6883 23.0516 8.88375 21.0344C7.1295 20.1046 6.46811 17.9408 7.40822 16.2029C8.34676 14.465 10.5309 13.8098 12.2852 14.7412C15.4283 16.4089 20.5226 18.3745 26.9538 18.2841C32.8842 18.1983 37.599 16.3777 40.5122 14.8644C42.2743 13.9486 44.4522 14.6226 45.3766 16.3683C46.3009 18.114 45.6207 20.2716 43.8585 21.1873C38.6871 23.8738 32.8764 25.3387 27.0593 25.4229C26.8782 25.426 26.6971 25.4276 26.5176 25.4276L26.5144 25.4245Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.8723 7.97192C20.5125 7.97192 21.8422 6.18734 21.8422 3.98596C21.8422 1.78457 20.5125 0 18.8723 0C17.232 0 15.9023 1.78457 15.9023 3.98596C15.9023 6.18734 17.232 7.97192 18.8723 7.97192Z",
    fill: "#25569D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M33.8918 7.97192C35.5321 7.97192 36.8618 6.18734 36.8618 3.98596C36.8618 1.78457 35.5321 0 33.8918 0C32.2516 0 30.9219 1.78457 30.9219 3.98596C30.9219 6.18734 32.2516 7.97192 33.8918 7.97192Z",
    fill: "#25569D"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoading);
export default __webpack_public_path__ + "static/media/loading.9949a74a298d70b099ee0c55cec1a38f.svg";
export { ForwardRef as ReactComponent };